import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { hasModelType as x, LayoutFactory as T } from "../LayoutFactory.mjs";
import { F as E, m as H, u as G } from "./tss-DN0acMKN.mjs";
import * as g from "react";
import { g as _ } from "./useThemeProps-wW47KG21.mjs";
import { u as P } from "./useEnhancedEffect-CJGo-L3B.mjs";
import { C as W } from "./checkbox-rhf-ClHnxDCX.mjs";
import { l as M } from "./lodash-5ofSKtz3.mjs";
import { C as O } from "./currency-field-rhf-Dy6BYAnr.mjs";
import { D as F } from "./default-error-messages.constants-BvAz67KV.mjs";
import { D as Q } from "./date-picker-rhf-BhjB5yrX.mjs";
import { L as N } from "./label-BgzuHADZ.mjs";
import { B as U } from "./Box-B5hjovXR.mjs";
import { S } from "./section-CLXJkN7r.mjs";
import { S as V } from "./select-field-rhf-XMBjNM_X.mjs";
import { T as z } from "./text-field-rhf-BcIvHLbk.mjs";
import { T as $ } from "./text-area-rhf-2Zvk0pu4.mjs";
function J(e, i, t, n, o) {
  const [a, u] = g.useState(() => o && t ? t(e).matches : n ? n(e).matches : i);
  return P(() => {
    if (!t)
      return;
    const r = t(e), s = () => {
      u(r.matches);
    };
    return s(), r.addEventListener("change", s), () => {
      r.removeEventListener("change", s);
    };
  }, [e, t]), a;
}
const I = {
  ...g
}, R = I.useSyncExternalStore;
function K(e, i, t, n, o) {
  const a = g.useCallback(() => i, [i]), u = g.useMemo(() => {
    if (o && t)
      return () => t(e).matches;
    if (n !== null) {
      const {
        matches: l
      } = n(e);
      return () => l;
    }
    return a;
  }, [a, e, n, o, t]), [r, s] = g.useMemo(() => {
    if (t === null)
      return [a, () => () => {
      }];
    const l = t(e);
    return [() => l.matches, (m) => (l.addEventListener("change", m), () => {
      l.removeEventListener("change", m);
    })];
  }, [a, t, e]);
  return R(s, r, u);
}
function X(e, i = {}) {
  const t = E(), n = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: o = !1,
    matchMedia: a = n ? window.matchMedia : null,
    ssrMatchMedia: u = null,
    noSsr: r = !1
  } = _({
    name: "MuiUseMediaQuery",
    props: i,
    theme: t
  });
  let s = typeof e == "function" ? e(t) : e;
  return s = s.replace(/^@media( ?)/m, ""), (R !== void 0 ? K : J)(s, o, a, u, r);
}
function Y({
  model: e,
  ...i
}) {
  const { checked: t = !1, id: n, label: o, required: a, status: u, value: r = "" } = e;
  return {
    defaultValue: t,
    id: n,
    label: o,
    name: n,
    onChange: M.noop,
    required: a,
    status: u,
    value: r,
    ...i
  };
}
function Z({
  model: e,
  mobileSize: i,
  ...t
}) {
  const { id: n, label: o, required: a, status: u, value: r, width: s = 5, max: c, min: l } = e, m = i ? 100 : s, h = c ? { message: F.max, value: c } : void 0, f = l ? { message: F.min, value: l } : void 0;
  return {
    defaultValue: r,
    id: n,
    label: o,
    max: h,
    min: f,
    name: n,
    required: a,
    status: u,
    width: m,
    ...t
  };
}
function q({
  model: e,
  mobileSize: i,
  ...t
}) {
  const { id: n, label: o, min: a, max: u, required: r, status: s, width: c } = e;
  return {
    label: o,
    maxDate: u,
    minDate: a,
    name: n,
    required: r,
    status: s,
    width: i ? 100 : c,
    ...t
  };
}
function B({
  model: e,
  mobileSize: i,
  ...t
}) {
  const { id: n, items: o, label: a, note: u, required: r, status: s, value: c, width: l = 5 } = e;
  return {
    defaultValue: c,
    id: n,
    items: o,
    label: a,
    name: n,
    note: u,
    required: r,
    status: s,
    width: i ? 100 : l,
    ...t
  };
}
function ee({
  model: e,
  mobileSize: i,
  ...t
}) {
  const { id: n, label: o, maxLength: a, minLength: u, pattern: r, required: s, status: c, value: l, width: m = 10 } = e, h = i ? 100 : m, f = r ? { message: F.pattern, value: new RegExp(r) } : void 0, v = a ? { message: F.maxLength, value: a } : void 0, p = u ? { message: F.minLength, value: u } : void 0;
  return {
    defaultValue: l,
    id: n,
    label: o,
    maxLength: v,
    minLength: p,
    minRows: 3,
    name: n,
    pattern: f,
    required: s,
    status: c,
    width: h,
    ...t
  };
}
function te({
  model: e,
  mobileSize: i,
  ...t
}) {
  const { label: n, id: o, maxLength: a, minLength: u, note: r, pattern: s, required: c, status: l, value: m, width: h = 4 } = e, f = i ? 100 : h, v = typeof s == "string" ? { message: F.pattern, value: new RegExp(s) } : s, p = a ? { message: F.maxLength, value: a } : void 0, k = u ? { message: F.minLength, value: u } : void 0;
  return {
    defaultValue: m,
    id: o,
    label: n,
    maxLength: p,
    minLength: k,
    name: o,
    note: r,
    pattern: v,
    required: c,
    status: l,
    width: f,
    ...t
  };
}
function b(e) {
  return /* @__PURE__ */ d.jsx(W, { ...Y(e) });
}
function L(e) {
  return /* @__PURE__ */ d.jsx(O, { ...Z(e) });
}
function j(e) {
  return /* @__PURE__ */ d.jsx(Q, { ...q(e) });
}
const ne = H()({
  grid: {
    "&:empty": {
      display: "none"
    }
  }
}), ae = 2, re = 1;
function w(e) {
  const {
    children: i,
    mobileSize: t = !1,
    model: { gap: n, label: o, orientation: a = "vertical" }
  } = e, { classes: u } = ne(), r = /* @__PURE__ */ d.jsx(
    U,
    {
      className: u.grid,
      display: "flex",
      flexDirection: a === "vertical" || t ? "column" : "row",
      ...a === "vertical" || t ? { rowGap: n || re } : { columnGap: n || ae },
      children: i
    }
  );
  return o ? /* @__PURE__ */ d.jsxs("label", { children: [
    /* @__PURE__ */ d.jsx(N, { children: o }),
    r
  ] }) : r;
}
function y({ children: e, model: i, icon: t }) {
  const { title: n, subtitle: o } = i;
  return /* @__PURE__ */ d.jsxs(S, { children: [
    /* @__PURE__ */ d.jsx(S.Header, { description: o, icon: t, title: n }),
    e
  ] });
}
function A(e) {
  return /* @__PURE__ */ d.jsx(V, { ...B(e) });
}
function C(e) {
  return /* @__PURE__ */ d.jsx(z, { ...te(e) });
}
function D(e) {
  return /* @__PURE__ */ d.jsx($, { ...ee(e) });
}
const ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CheckboxField: b,
  CurrencyField: L,
  DateField: j,
  Group: w,
  Section: y,
  SelectField: A,
  TextField: C,
  TextareaField: D
}, Symbol.toStringTag, { value: "Module" }));
function oe(e) {
  const { model: i } = e;
  return i.type in ie;
}
function se(e) {
  if (x(e, "CheckboxField"))
    return /* @__PURE__ */ d.jsx(b, { ...e });
  if (x(e, "CurrencyField"))
    return /* @__PURE__ */ d.jsx(L, { ...e });
  if (x(e, "DateField"))
    return /* @__PURE__ */ d.jsx(j, { ...e });
  if (x(e, "Group"))
    return /* @__PURE__ */ d.jsx(w, { ...e });
  if (x(e, "Section"))
    return /* @__PURE__ */ d.jsx(y, { ...e });
  if (x(e, "SelectField"))
    return /* @__PURE__ */ d.jsx(A, { ...e });
  if (x(e, "TextField"))
    return /* @__PURE__ */ d.jsx(C, { ...e });
  if (x(e, "TextareaField"))
    return /* @__PURE__ */ d.jsx(D, { ...e });
}
function we({ control: e, layout: i, models: t, renderElement: n, validation: o = {} }) {
  const { breakpoints: a } = G(), u = X(a.down("sm"));
  return /* @__PURE__ */ d.jsx(
    T,
    {
      layout: i,
      models: t,
      renderElement: (r) => {
        const { model: s } = r, c = o[s.id], h = { ...r, control: e, mobileSize: u, model: s, validate: typeof c == "function" ? c : void 0, ...typeof c == "object" ? c : void 0 };
        let f = typeof n == "function" ? n(h) : void 0;
        if (typeof f > "u" && oe(h) && (f = se(h)), typeof f > "u")
          throw new Error(`Could not find a component that matches ${JSON.stringify(r)}`);
        return f;
      }
    }
  );
}
var ue = /* @__PURE__ */ ((e) => (e.CheckboxField = "CheckboxField", e.CurrencyField = "CurrencyField", e.DateField = "DateField", e.Group = "Group", e.NumberField = "NumberField", e.PercentageField = "PercentageField", e.Section = "Section", e.SelectField = "SelectField", e.TextField = "TextField", e.TextareaField = "TextareaField", e))(ue || {});
export {
  b as A,
  ue as B,
  j as D,
  we as F,
  w as G,
  A as S,
  D as T,
  L as a,
  y as b,
  C as c,
  X as u
};
//# sourceMappingURL=enums-uX3E-11l.mjs.map
